import React from "react" ;
import { ReactNode } from "react" ;
import ObservableState from "../utils/ObservableState" ;
import * as ui from "../native" ;
import ObservableComponent from "./ObservableComponent" ;
import BaseUIProps , { copyBaseUIProps } from "../native/ui/BaseUIProps" ;
import ObjectObservable from "../utils/ObjectObservable" ;
import Button from "./Button" ;
import ToolTipWrapper from "./ToolTipWrapper" ;
import IconView from "./IconView" ;
import { BuildContext } from "../classes/BuildContext" ;

type _CollapseSideMenuButtonOnPressed = ( ) => void ;

type _Button11111111OnPressed = ( d3eState : CollapseSideMenuButtonRefs ) => void ;


  export  interface  CollapseSideMenuButtonProps extends  BaseUIProps {   key?: string ;
   title: string ;
   icon: ui.IconData ;
   selectedMenu: string ;
   onPressed?: _CollapseSideMenuButtonOnPressed ;
 }
/// To store state data for CollapseSideMenuButton 
   class  CollapseSideMenuButtonRefs {  public button11111111: Button11111111State = new Button11111111State() ;
 }

   interface  Button11111111WithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: CollapseSideMenuButtonRefs ;
   _onPressedButton?: _Button11111111OnPressed ;
   icon: ui.IconData ;
   selectedMenu: string ;
   title: string ;
 }

   class  Button11111111State extends  ObjectObservable {  private _hover: boolean = false ;
  private _disable: boolean = false ;
  public get hover (  ) : boolean {
 return this._hover ; 
 }
  public setHover ( val : boolean ) {
 let isValChanged :boolean=this._hover !== val;

if ( !isValChanged ) {
 return ; 
 }

this._hover=val;

this.fire('hover',this);
 }
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
 }

   class  _Button11111111WithState extends  ObservableComponent<Button11111111WithStateProps> {   button11111111FocusNode: ui.FocusNode = new ui.FocusNode() ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : Button11111111WithStateProps ) {
 super(props);

this.initState();
 }
  public get button11111111 (  ) : Button11111111State {
 return this.props.d3eState.button11111111 ; 
 }
  public get icon (  ) : ui.IconData {
 return this.props.icon ; 
 }
  public get selectedMenu (  ) : string {
 return this.props.selectedMenu ; 
 }
  public get title (  ) : string {
 return this.props.title ; 
 }
  public get d3eState (  ) : CollapseSideMenuButtonRefs {
 return this.props.d3eState ; 
 }
  public get _onPressedButton (  ) : _Button11111111OnPressed {
 return this.props._onPressedButton ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('button11111111',null,this.button11111111);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.on([ 'button11111111', 'button11111111.hover', 'icon', 'selectedMenu', 'title' ],this.rebuild);
 }
  public button11111111OnEnter ( event ) : void {
 return this.button11111111.setHover(true) ; 
 }
  public button11111111OnExit ( event ) : void {
 return this.button11111111.setHover(false) ; 
 }
  public dispose (  ) : void {
 this.button11111111.setHover(false);

super.dispose();
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Container({ margin:ui.EdgeInsets.symmetric({horizontal:0.0,vertical:5.0,transitions:new Map()}), width:Number.POSITIVE_INFINITY, child:Button({ padding:this.button11111111.hover ? ui.EdgeInsets.all(8.0,new Map()) : this.selectedMenu == this.title ? ui.EdgeInsets.all(8.0,new Map()) : ui.EdgeInsets.symmetric({horizontal:12.0,vertical:8.0,transitions:new Map()}), decoration:this.button11111111.hover ? new ui.BoxDecoration({color:new ui.Color(0xff2b2b2b),borderRadius:ui.BorderRadiusExt.only({topLeft:ui.RadiusExt.elliptical({x:18,y:18}),topRight:ui.RadiusExt.elliptical({x:0,y:0}),bottomLeft:ui.RadiusExt.elliptical({x:18,y:18}),bottomRight:ui.RadiusExt.elliptical({x:0,y:0})})}) : this.selectedMenu == this.title ? new ui.BoxDecoration({borderRadius:ui.BorderRadiusExt.only({topLeft:ui.RadiusExt.elliptical({x:18,y:18}),topRight:ui.RadiusExt.elliptical({x:0,y:0}),bottomLeft:ui.RadiusExt.elliptical({x:18,y:18}),bottomRight:ui.RadiusExt.elliptical({x:0,y:0})}),color:cStyle.c1}) : new ui.BoxDecoration({borderRadius:ui.BorderRadiusExt.only({topLeft:ui.RadiusExt.elliptical({x:18,y:18}),topRight:ui.RadiusExt.elliptical({x:0,y:0}),bottomLeft:ui.RadiusExt.elliptical({x:18,y:18}),bottomRight:ui.RadiusExt.elliptical({x:0,y:0})}),color:new ui.Color(0xff000000)}), disable:this.button11111111.disable, onPressed:(  ) => {
 this._onPressedButton(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, states:ui.joinStates({ 'data-c0':this.button11111111.hover, 'data-c1':this.selectedMenu == this.title },this.props.states), child:ui.Row({ mainAxisSize:ui.MainAxisSize.max, children:[ ToolTipWrapper({ message:this.title, child:IconView({ size:18, icon:this.icon, className:'x881' }), key:'0' }) ] }), onEnter:( event ) => {
 this.button11111111OnEnter(event);
 }
, onExit:( event ) => {
 this.button11111111OnExit(event);
 }
 }), className:ui.join('CollapseSideMenuButton x0c9 ' , this.props.className ?? ''), states:ui.joinStates({ 'data-c0':this.button11111111.hover, 'data-c1':this.selectedMenu == this.title },this.props.states), ...copyBaseUIProps(this.props,) }) ; 
 }
 }
function Button11111111WithState ( props : Button11111111WithStateProps ) {
 return React.createElement(_Button11111111WithState,props) ; 
 }


   class  _CollapseSideMenuButtonState extends  ObservableComponent<CollapseSideMenuButtonProps> {   static defaultProps = { title:'', icon:null, selectedMenu:'', onPressed:null } ;
   d3eState: CollapseSideMenuButtonRefs = new CollapseSideMenuButtonRefs() ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : CollapseSideMenuButtonProps ) {
 super(props);

this.initState();
 }
  public get title (  ) : string {
 return this.props.title ; 
 }
  public get icon (  ) : ui.IconData {
 return this.props.icon ; 
 }
  public get selectedMenu (  ) : string {
 return this.props.selectedMenu ; 
 }
  public initState (  ) {
 super.initState();

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.on([ 'icon', 'selectedMenu', 'title' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : CollapseSideMenuButtonProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.title !== this.props.title ) {
 this.fire('title',this);
 }

if ( prevProps.icon !== this.props.icon ) {
 this.fire('icon',this);
 }

if ( prevProps.selectedMenu !== this.props.selectedMenu ) {
 this.fire('selectedMenu',this);
 }
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return Button11111111WithState({ d3eState:this.d3eState, _onPressedButton:this.onPressedButton, icon:this.icon, selectedMenu:this.selectedMenu, title:this.title, className:this.props.className ?? '', ...copyBaseUIProps(this.props,) }) ; 
 }
  public onPressedButton  =  ( d3eState : CollapseSideMenuButtonRefs ) : void  =>  {
 if ( this.onPressed !== null ) {
 this.onPressed();

d3eState.button11111111.setHover(false);
 }
 }
  public get onPressed (  ) : _CollapseSideMenuButtonOnPressed {
 return this.props.onPressed ; 
 }
  public get button11111111 (  ) {
 return this.d3eState.button11111111 ; 
 }
 }
export default function CollapseSideMenuButton ( props : CollapseSideMenuButtonProps ) {
 return React.createElement(_CollapseSideMenuButtonState,{ ..._CollapseSideMenuButtonState.defaultProps, ...props }) ; 
 }
